import { AccessibilityHelper } from "../GlobalAssets/js/accessibilityHelper";
class NavigationDesktop {
  constructor(component) {
    this.refs = {
      submenuToggle: '.js-navigation-desktop-submenu-toggle',
      submenu: '.js-navigation-desktop-submenu',
      underlay: '.js-underlay',
    };

    this.dom = {
      $component: component,
      $submenuToggles: component.querySelectorAll(this.refs.submenuToggle),
      $submenus: component.querySelectorAll(this.refs.submenu),
      $underlay: document.querySelector(this.refs.underlay),
    };

    this.state = {
      activeSubmenu: null,
      accessibilityHelper: new AccessibilityHelper(),
      focusTrap: null,
    };

    this.init();

    this.mount();
  }

  init() {
    const { dom, state } = this;

    if (dom.$submenus.length === 0) return;

    dom.$submenus.forEach($el => {
      // get button that controls this submenu
      const $button = dom.$component.querySelector(
        `[aria-controls="${$el.id}"]`
      );

      // get xposition of left edge of button relative to viewport
      const buttonRect = $button.getBoundingClientRect();
      const buttonXPos = buttonRect.left;

      // get xposition of left edge of submenu relative to viewport
      const submenuRect = $el.getBoundingClientRect();
      const submenuXPos = submenuRect.left;

      // calculate difference
      const xPosDiff = buttonXPos - submenuXPos;

      // apply transform to submenu to align left edges with button
      $el.style.paddingLeft = `${xPosDiff}px`;
    });
  }

  mount() {
    const { dom, state } = this;

    if (dom.$submenuToggles) {
      dom.$submenuToggles.forEach($el => {
        $el.addEventListener('click', this.handleSubmenuToggleClick.bind(this));
      });
    }

    if (dom.$underlay) {
      dom.$underlay.addEventListener('click', this.hideUnderlay.bind(this));
    }

    dom.$component.addEventListener('focusout', this.handleFocusOut.bind(this));
  }

  hideUnderlay() {
    const { state, dom } = this;

    if (state.activeSubmenu) {
      const $activeButton = dom.$component.querySelector(
        `[aria-controls="${state.activeSubmenu}"]`
      );
      this.closeSubmenu($activeButton);
    }

    dom.$underlay.classList.remove('is-active');
    document.body.classList.remove('scroll-locked');
    state.accessibilityHelper.removeEscapeKeyListener();
  }

  showUnderlay() {
    const { dom, state } = this;
    dom.$underlay.classList.add('is-active');
    document.body.classList.add('scroll-locked');
    state.accessibilityHelper.addEscapeKeyListener(this.hideUnderlay.bind(this));
  }

  handleSubmenuToggleClick(e) {
    const { state } = this;
    const $button = e.currentTarget;
    const targetId = $button.getAttribute('aria-controls');

    if (state.activeSubmenu === targetId) {
      // submenu clicked is already open, so close it
      this.closeSubmenu($button);
      this.hideUnderlay()
      return;
    }

    if (state.activeSubmenu && state.activeSubmenu !== targetId) {
      // another submenu is open, add the 'no-transition' class to submenus and open the new submenu
      const $activeSubmenu = document.getElementById(state.activeSubmenu);
      const $clickedSubmenu = document.getElementById(targetId);
      const $activeButton = this.dom.$component.querySelector(
        `[aria-controls="${state.activeSubmenu}"]`
      );

      $activeSubmenu.classList.add('no-transition');
      $clickedSubmenu.classList.add('no-transition');
      this.closeSubmenu($activeButton);
      this.openSubmenu($button);
      // Remove the 'no-transition' class after a short delay to allow transitions on next open
      setTimeout(() => {
        $activeSubmenu.classList.remove('no-transition');
        $clickedSubmenu.classList.remove('no-transition');
      }, 300);
      return;
    }

    // Open the clicked submenu
    this.openSubmenu($button);
    this.showUnderlay();
  }

  openSubmenu($button) {
    const { state } = this;
    const targetId = $button.getAttribute('aria-controls');
    const targetMenu = document.getElementById(targetId);

    $button.setAttribute('aria-expanded', 'true');
    $button.classList.add('is-active');
    targetMenu.classList.add('is-active');

    state.accessibilityHelper.updateElementAccessibility(targetMenu, true);
    state.activeSubmenu = targetId;
  }

  closeSubmenu($button) {
    const { state } = this;
    const targetId = $button.getAttribute('aria-controls');
    const targetMenu = document.getElementById(targetId);

    $button.setAttribute('aria-expanded', 'false');
    $button.classList.remove('is-active');
    targetMenu.classList.remove('is-active');

    state.accessibilityHelper.updateElementAccessibility(targetMenu, false);
    state.activeSubmenu = null;
  }

  handleFocusOut(e) {
    const { dom, state } = this;

    if (!state.activeSubmenu) return;
    if (e.relatedTarget && !dom.$component.contains(e.relatedTarget)) {
      this.hideUnderlay();
    }
  }

}

const $navigationDesktop = document.querySelector('.js-navigation-desktop');
new NavigationDesktop($navigationDesktop);